import React from 'react';
import { UniversalContentImporter } from './UniversalContentImporter';
import { useBulkPageImport } from '@/hooks/content-generator/useBulkPageImport';

interface ProjectImportPagesEmptyStateProps {
  projectId: string;
  onImportComplete?: () => void;
}

export const ProjectImportPagesEmptyState: React.FC<ProjectImportPagesEmptyStateProps> = ({
  projectId,
  onImportComplete
}) => {
  const bulkImportMutation = useBulkPageImport(projectId);

  const handleBulkImport = async (selectedIds: string[]) => {
    try {
      await bulkImportMutation.mutateAsync(selectedIds);
      onImportComplete?.();
    } catch (error) {
      console.error('Failed to import pages:', error);
      throw error;
    }
  };

  return (
    <div className="h-[600px]">
      <UniversalContentImporter
        contentType="pages"
        projectId={projectId}
        onBulkImport={handleBulkImport}
        layout="list"
        showBulkActions={true}
        showClearButton={false}
        showSearch={true}
        className="h-full"
      />
    </div>
  );
}; 